import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import React from 'react'

export const CommunicationReceiver = ({
  receiver = {},
  index,
  onUpdate,
  onRemove,
  editMode = true,
  validationHook,
}) => {
  const {
    toEmail = '',
    toPhone = '',
    toWhatsAppId = '',
    toUserId = '',
    toPatientId = '',
  } = receiver

  const validation = validationHook?.getCommunicationReceiverValidation?.(index)
  const hasError = validation?.showError

  const handleFieldChange = (field, value) => {
    if (editMode && onUpdate) {
      onUpdate(index, field, value)
    }
  }

  const handleRemove = () => {
    if (editMode && onRemove) {
      onRemove(index)
    }
  }

  const inputStyle = {
    padding: '8px 12px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    width: '100%',
  }

  const errorStyle = {
    ...inputStyle,
    borderColor: '#dc3545',
  }

  return (
    <div className="mb-3 p-3" style={{ border: '1px solid #e9ecef', borderRadius: '6px', backgroundColor: '#f8f9fa' }}>
      <div className="d-flex justify-content-between align-items-start mb-2">
        <h6 className="mb-0">Recipient {index + 1}</h6>
        <DeleteOutlineIcon
          style={{
            cursor: editMode ? 'pointer' : 'not-allowed',
            opacity: editMode ? 1 : 0.5,
            fontSize: '18px',
            color: '#dc3545'
          }}
          onClick={handleRemove}
        />
      </div>

      <div className="row g-2">
        {/* Email Field */}
        <div className="col-12 col-md-6">
          <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', marginBottom: '4px' }}>
            To Email
          </label>
          <input
            type="email"
            value={toEmail}
            placeholder="recipient@example.com"
            disabled={!editMode}
            style={hasError ? errorStyle : inputStyle}
            onChange={(e) => handleFieldChange('toEmail', e.target.value)}
          />
        </div>

        {/* Phone Field */}
        <div className="col-12 col-md-6">
          <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', marginBottom: '4px' }}>
            To Phone
          </label>
          <input
            type="tel"
            value={toPhone}
            placeholder="+1234567890"
            disabled={!editMode}
            style={hasError ? errorStyle : inputStyle}
            onChange={(e) => handleFieldChange('toPhone', e.target.value)}
          />
        </div>

        {/* WhatsApp ID Field */}
        <div className="col-12 col-md-6">
          <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', marginBottom: '4px' }}>
            To WhatsApp ID
          </label>
          <input
            type="text"
            value={toWhatsAppId}
            placeholder="WhatsApp ID"
            disabled={!editMode}
            style={hasError ? errorStyle : inputStyle}
            onChange={(e) => handleFieldChange('toWhatsAppId', e.target.value)}
          />
        </div>

        {/* User ID Field */}
        <div className="col-12 col-md-6">
          <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', marginBottom: '4px' }}>
            To User ID
          </label>
          <input
            type="text"
            value={toUserId}
            placeholder="User ID"
            disabled={!editMode}
            style={hasError ? errorStyle : inputStyle}
            onChange={(e) => handleFieldChange('toUserId', e.target.value)}
          />
        </div>

        {/* Patient ID Field */}
        <div className="col-12">
          <label className="form-label" style={{ fontSize: '12px', fontWeight: '500', marginBottom: '4px' }}>
            To Patient ID
          </label>
          <input
            type="text"
            value={toPatientId}
            placeholder="Patient ID"
            disabled={!editMode}
            style={hasError ? errorStyle : inputStyle}
            onChange={(e) => handleFieldChange('toPatientId', e.target.value)}
          />
        </div>
      </div>

      {/* Validation Error */}
      {hasError && (
        <small className="text-danger mt-2 d-block">
          {validation.errorMessage || 'Please provide at least one contact method (Email, Phone, or WhatsApp)'}
        </small>
      )}

      {/* Help Text */}
      <small className="text-muted mt-2 d-block">
        Provide at least one contact method for this recipient
      </small>
    </div>
  )
}

export default CommunicationReceiver